import { supabase } from "@/integrations/supabase/client";

const EDGE_FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/toggle-staff-leave`;

export const toggleStaffLeave = async (
  staffId: string,
  action: 'activate' | 'deactivate',
): Promise<{
  success: boolean;
  data?: { reassigned_count?: number; restored_count?: number; substitutes?: string[] };
  error?: string;
}> => {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token;
    if (!token) return { success: false, error: 'Non authentifié' };

    const res = await fetch(EDGE_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ staff_id: staffId, action }),
    });

    const json = await res.json();

    if (!res.ok) {
      return { success: false, error: json.error || `Erreur ${res.status}` };
    }

    return { success: true, data: json };
  } catch (error) {
    console.error('[staffLeave] toggleStaffLeave error:', error);
    return { success: false, error: 'Erreur réseau' };
  }
};

export const getStaffLeaveStatus = async (
  staffId: string,
): Promise<{ success: boolean; data?: { is_on_leave: boolean }; error?: string }> => {
  try {
    const { data, error } = await supabase
      .from('users')
      .select('is_on_leave')
      .eq('id', staffId)
      .single();

    if (error) throw error;

    return { success: true, data: { is_on_leave: data?.is_on_leave ?? false } };
  } catch (error) {
    console.error('[staffLeave] getStaffLeaveStatus error:', error);
    return { success: false, error: 'Impossible de récupérer le statut de congé' };
  }
};
